import { constantRoutes } from '@/router/routerConfig'
import routerTeacher from '@/router/teacher'
import routerStudent from '@/router/student'

const permission = {
  // namespaced: true,
  state: {
    routes: constantRoutes,
    navbarRouters: []
  },
  mutations: {
    SET_NAVBAR_ROUTERS: (state, routers) => {
      state.navbarRouters = routers
    },
  },
  actions: {
    // 生成路由
    GenerateRoutes({ commit, rootState }) {
      return new Promise(resolve => {
        let routerSource = rootState.userInfo.userType === 3 ? routerTeacher : routerStudent
        // routerSource.push({ path: '*', redirect: '/404', hidden: true })
        commit('SET_NAVBAR_ROUTERS', routerSource)
        resolve(routerSource)
      })
    }
  }
}

export default permission
